/**
 * Vendor token storage — standalone module with zero imports.
 * Used by the API client and auth hook without circular dependencies.
 *
 * Uses sessionStorage so the token survives page refresh within the same tab.
 * Clears when the tab closes.
 *
 * NOTE: BE currently requires vendor_token header on EVERY request (not just
 * authenticate). Until BE migrates to cookie-only auth, sessionStorage is
 * necessary to persist the token across refresh. Once BE accepts the httpOnly
 * cookie for all endpoints, sessionStorage can be removed and the token only
 * needs to live in memory for the initial authenticate call.
 */
const STORAGE_KEY = 'vendor_token';

let vendorToken: string | null = null;

// Hydrate from sessionStorage on module load (survives refresh)
try {
  vendorToken = sessionStorage.getItem(STORAGE_KEY);
} catch {
  // sessionStorage unavailable (SSR, private browsing edge cases)
}

export function getVendorToken(): string | null {
  return vendorToken;
}

export function setVendorToken(token: string): void {
  vendorToken = token;
  try {
    sessionStorage.setItem(STORAGE_KEY, token);
  } catch {
    // sessionStorage unavailable
  }
}

export function clearVendorToken(): void {
  vendorToken = null;
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // sessionStorage unavailable
  }
}
